import React from 'react';
import IconHolder from '../Common/IconHolder';

export default function TitleComponent(props) {
    return (
        <React.Fragment>
           {props.icon && <div className="d-flex justify-content-center mt-1">
                <IconHolder icon={props.icon} viewBox="0 0 24 24" />
            </div>}
            <h4 className="text-center mt-3 mb-3"><b>{props.title}</b></h4>
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/Common/TitleComponent.js